import type { AxiosInstance } from "axios";

export type OpenApiCtor<T> = new (
  configuration?: any,
  basePath?: string,
  axios?: AxiosInstance
) => T;

/**
 * Returns a tiny factory that instantiates OpenAPI-generated API classes
 * with our shared authed axios instance.
 *
 * This keeps service modules free of noisy placeholder args while still
 * allowing us to inject `axiosInstance` (needed for OIDC interceptors).
 */
export function createOpenApiClientFactory(baseURL: string, axiosInstance: AxiosInstance) {
  return function createApi<T>(Ctor: OpenApiCtor<T>): T {
    // OpenAPI Generator's TS axios clients use (configuration?, basePath?, axios?).
    // We inject basePath + axios, leaving configuration undefined.
    return new Ctor(undefined, baseURL, axiosInstance);
  };
}

